// extracted by mini-css-extract-plugin
export default {"regenerateBtn":"ActionsDropdownButton_regenerateBtn__URoDX"};